import { section } from '@/glow';
import { qs, qsa } from '@fluorescent/dom';

import navigationDots from '@/lib/navigation-dots';

const selectors = {
  slider: '[data-slider]',
  slide: '[data-slide]',
};

section('quote', {
  onLoad() {
    const sliderContainer = qs(selectors.slider, this.container);
    const slides = qsa(selectors.slide, this.container);

    import('flickity').then(({ default: Flickity }) => {
      this.slider = new Flickity(sliderContainer, {
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: true,
        pageDots: false,
        cellAlign: 'center',
        draggable: false,
        pauseAutoPlayOnHover: false,
        autoPlay: parseInt(sliderContainer.dataset.timer),
      });
      let dotNavigation = null;

      setTimeout(() => {
        this.slider.resize();
      }, 250);

      if (slides.length > 1) {
        dotNavigation = navigationDots(this.container, this.slider);

        this.slider.on('select', () => {
          dotNavigation.update(this.slider.selectedIndex);
        });
      }
    });
  },

  onBlockSelect({ target: slide }) {
    this.slider.select(slide.dataset.index);
    this.slider.pausePlayer();
  },

  onBlockDeselect() {
    this.slider.unpausePlayer();
  },

  onUnload() {
    this.slider.destroy();
    this.dotNavigation && this.dotNavigation.unload();
  },
});
